import { render, staticRenderFns } from "./scaleReal.vue?vue&type=template&id=511965ed&scoped=true"
import script from "./scaleReal.vue?vue&type=script&lang=js"
export * from "./scaleReal.vue?vue&type=script&lang=js"
import style0 from "./scaleReal.vue?vue&type=style&index=0&id=511965ed&prod&scoped=true&lang=scss"
import style1 from "./scaleReal.vue?vue&type=style&index=1&id=511965ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511965ed",
  null
  
)

export default component.exports